import { Link } from 'react-router-dom';
import { TrendingUp, PauseCircle, Award, Target, Users, ChevronLeft } from 'lucide-react';

export const DIGEST_TABS = [
  { id: 'all', label: 'الكل', icon: Users, key: 'total', tone: 'border-amber-200 text-amber-800 bg-amber-50' },
  { id: 'progressed', label: 'تقدّموا', icon: TrendingUp, key: 'progressed', tone: 'border-green-200 text-green-800 bg-green-50' },
  { id: 'stalled', label: 'توقّفوا', icon: PauseCircle, key: 'stalled', tone: 'border-rose-200 text-rose-800 bg-rose-50' },
  { id: 'new', label: 'نالوا وساماً جديداً', icon: Award, key: 'new_badges', tone: 'border-yellow-300 text-yellow-800 bg-yellow-50' },
  { id: 'near', label: 'قريبون من الوسام التالي', icon: Target, key: 'near_next', tone: 'border-blue-200 text-blue-800 bg-blue-50' },
];

export const filterDigest = (items, tab, nearDays) => items.filter((i) => {
  if (tab === 'progressed') return i.delta > 0;
  if (tab === 'stalled') return !i.active_on_day;
  if (tab === 'new') return i.newly_earned.length > 0;
  if (tab === 'near') return i.next_badge && i.next_badge.remaining <= nearDays;
  return true;
});

export const DigestStat = ({ tab, value, active, onClick }) => {
  const Icon = tab.icon;
  return (
    <button
      type="button"
      onClick={onClick}
      className={`rounded-2xl border-2 p-4 text-right transition-[transform,box-shadow] hover:-translate-y-0.5 hover:shadow-md ${tab.tone} ${active ? 'ring-2 ring-offset-2 ring-amber-500' : ''}`}
      data-testid={`digest-stat-${tab.id}`}
    >
      <Icon className="w-5 h-5 mb-2 opacity-80" />
      <div className="text-3xl font-bold">{value ?? 0}</div>
      <div className="text-xs mt-1 opacity-80">{tab.label}</div>
    </button>
  );
};

const StatusChip = ({ item }) => {
  if (item.delta > 0) return <span className="text-[11px] px-2 py-0.5 rounded-full bg-green-100 text-green-800 font-semibold">+{item.delta} يوم</span>;
  const idle = item.days_idle == null ? 'لم ينشط بعد القمة' : `متوقف منذ ${item.days_idle} يوم`;
  return <span className="text-[11px] px-2 py-0.5 rounded-full bg-rose-100 text-rose-800 font-semibold">{idle}</span>;
};

export const DigestRow = ({ item }) => (
  <div className="flex flex-col md:flex-row md:items-center gap-3 p-4 border-b last:border-b-0 hover:bg-amber-50/40 transition-colors" data-testid={`digest-row-${item.reader_number}`}>
    <div className="flex-1 min-w-0">
      <div className="flex items-center gap-2 flex-wrap">
        <span className="font-bold text-accent truncate">{item.name || '—'}</span>
        <span className="font-mono text-xs text-muted-foreground">#{item.reader_number}</span>
        <span className="text-[10px] px-2 py-0.5 rounded-full bg-muted text-muted-foreground">{item.gender === 'female' ? 'قارئة' : 'قارئ'}</span>
        <StatusChip item={item} />
        {item.newly_earned.map((n) => (
          <span key={n} className="text-[11px] px-2 py-0.5 rounded-full bg-yellow-100 text-yellow-900 font-semibold flex items-center gap-1">
            <Award className="w-3 h-3" /> {n}
          </span>
        ))}
      </div>
      <p className="text-[11px] text-muted-foreground mt-1">
        بلغ القمة {item.peak_date} · آخر نشاط {item.last_active_date || '—'}
      </p>
    </div>
    <div className="flex items-center gap-4 shrink-0">
      <div className="text-center">
        <div className="text-2xl font-bold text-amber-700" data-testid={`digest-counter-${item.reader_number}`}>{item.counter}</div>
        <div className="text-[10px] text-muted-foreground">يوم استمرار</div>
      </div>
      <div className="w-40">
        {item.next_badge ? (
          <>
            <div className="flex justify-between text-[10px] text-muted-foreground mb-1">
              <span className="truncate">{item.next_badge.name}</span>
              <span>باقٍ {item.next_badge.remaining}</span>
            </div>
            <div className="h-1.5 rounded-full bg-muted overflow-hidden">
              <div className="h-full bg-amber-500" style={{ width: `${item.next_badge.progress_percent}%` }} />
            </div>
          </>
        ) : <span className="text-[11px] text-green-700 font-semibold">نال كل أوسمة الاستمرار</span>}
      </div>
      <Link to={`/admin/badges/progress?rn=${item.reader_number}`} className="p-2 rounded-lg hover:bg-amber-100 text-amber-700" title="إدارة أوسمته" data-testid={`digest-manage-${item.reader_number}`}>
        <ChevronLeft className="w-4 h-4" />
      </Link>
    </div>
  </div>
);
